export enum DataSource {
    NETWORK = 'NETWORK',
    NETWORK_GQL = 'NETWORK_GQL',
    NETWORK_GATEWAY = 'NETWORK_GATEWAY',
    SERVICE_WORKER = 'SERVICE_WORKER',
    INDEXDB = 'INDEXDB',
    IN_MEMORY = 'IN_MEMORY',
    NO_QUERY = 'NO_QUERY',
}
